import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchFieldComponent {
  @Input() caption: string;
  @Input() searchQuery: string = '';
  @Input() filteredItems: any[] = [];
  @Input() bordered: boolean = false;
  @Output() searchQueryChange = new EventEmitter<string>();

  onSearchChange() {
    this.searchQueryChange.emit(this.searchQuery);
  }
}
